'use client'

import { useEffect } from 'react'
import { useUserStore } from '@/store/user-store'
import FloatingCartButton from '@/components/layout/floating-cart'

export default function AppProvider({ children }: { children: React.ReactNode }) {
  const { initGuest, user, guestInitialized } = useUserStore()

  useEffect(() => {
    // 首次访问自动初始化游客账号
    if (!guestInitialized || !user) {
      initGuest()
    }
  }, [initGuest, guestInitialized, user])

  return (
    <>
      {children}
      <FloatingCartButton />
    </>
  )
}
